import {Chromeless} from '@freckle/classroom/ts/hooks/chromeless/component'
import {LoggedRoute} from './../logged-route'
import {
  ActivityFeedHandler,
  AssignmentsHandler,
  DashboardHandler,
  ChromelessErrorHandler,
  MobileReminderHandler,
  ParentWelcomeHandler,
  PricingHandler,
  CheckoutHandler,
  ReferralProgramHandler,
  PremiumReferralProgramHandler,
  ProfileSettingsHandler,
  ProductSettingsHandler,
  StudentGoalsHandler,
  TeacherOnboardingHandler,
  ReportsOverviewHandler,
  ChromelessPreview,
} from './lazy'

export const routerV2Common = [
  {
    path: '/dashboard',
    element: <LoggedRoute component={DashboardHandler} />,
  },
  {
    path: '/chromeless/error',
    element: (
      <Chromeless>
        <LoggedRoute component={ChromelessErrorHandler} />
      </Chromeless>
    ),
  },
  {
    path: '/activity-feed',
    element: <LoggedRoute component={ActivityFeedHandler} />,
  },
  {
    path: '/student-goals',
    element: <LoggedRoute component={StudentGoalsHandler} />,
  },
  {
    path: '/ela/student-goals',
    element: <LoggedRoute component={StudentGoalsHandler} />,
  },
  {
    path: '/assignments',
    element: <LoggedRoute component={AssignmentsHandler} />,
  },
  {
    path: '/teacher-onboarding',
    element: <LoggedRoute component={TeacherOnboardingHandler} fullScreen />,
  },
  {
    path: '/parent-welcome',
    element: <LoggedRoute component={ParentWelcomeHandler} dashboardType="minimal" />,
  },
  {
    path: '/mobile-reminder',
    element: <LoggedRoute component={MobileReminderHandler} fullScreen />,
  },
  {
    path: '/pricing',
    element: <LoggedRoute component={PricingHandler} />,
  },
  {
    path: '/checkout',
    element: <LoggedRoute component={CheckoutHandler} />,
  },
  {
    path: '/referral-program',
    element: <LoggedRoute component={ReferralProgramHandler} dashboardType="minimal" />,
  },
  {
    path: '/premium-referral-program',
    element: <LoggedRoute component={PremiumReferralProgramHandler} dashboardType="minimal" />,
  },
  {
    path: '/settings/profile',
    element: <LoggedRoute component={ProfileSettingsHandler} />,
  },
  {
    path: '/settings/product',
    element: <LoggedRoute component={ProductSettingsHandler} />,
  },
  {
    path: '/reports-overview',
    element: <LoggedRoute component={ReportsOverviewHandler} />,
  },
  {
    path: '/chromeless-preview',
    element: <LoggedRoute component={ChromelessPreview} fullScreen />,
  },
]
